import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { useLayout } from "@/providers";
import { Notifications } from "./Notifications";

const NotificationManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle
                text="Notifications"
                id="notification-management-heading"
              />
              <ToolbarDescription>
                You can manage your notifications here.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
      <Container>
        <Notifications />
      </Container>
    </Fragment>
  );
};

export { NotificationManagement };
